import { render, staticRenderFns } from "./chart-card.vue?vue&type=template&id=10c5ae17&scoped=true&"
import script from "./chart-card.vue?vue&type=script&lang=ts&"
export * from "./chart-card.vue?vue&type=script&lang=ts&"
import style0 from "./chart-card.vue?vue&type=style&index=0&id=10c5ae17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5ae17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
